import React from "react";
import { Menu } from "antd";
const { Item } = Menu;
function ChatItemAction({
    action,
    assignStatus,
    ownerStatus,
    adminStatus,
    actionCb,
    permissions,
    text,
}) {
    if (permissions && permissions[assignStatus][ownerStatus][adminStatus]) {
        return (
            <Item key={action} onClick={() => actionCb(action)}>
                {text}
            </Item>
        );
    }
    return null;
}
export default ChatItemAction;
